import { HtmlContentProperty } from '../../../interfaces/html-content-property';
import { pdsUtils } from '../../../pds-utils';
import { HtmlContentTarget } from '../../../interfaces/html-content-target';

// font size simply gets the current font size and converts it to pixels
export const fontSize: HtmlContentProperty = {
  name: 'fontSize',
  value: (target: HtmlContentTarget, style: CSSStyleDeclaration) => {
    return pdsUtils.getCssValueInPx(style.fontSize);
  }
};
